<template>
  <section class="vps-singapura">
    <Hero />
    <Pricing />
    <Benefit />
  </section>
</template>

<script>
import { useHead } from "@vueuse/head";
import { defineComponent, computed, reactive } from "vue";
import Hero from "@/components/views/services/vpssg/hero.vue";
import Pricing from "@/components/views/services/vpssg/pricing.vue";
import Benefit from "@/components/views/services/vpssg/benefit.vue";

export default defineComponent({
  setup() {
    const siteData = reactive({
      title: "VPS Singapura | Zoinix Inter Technology",
      url: "https://zoinix.com/services/vps-singapura",
    });

    useHead({
      title: computed(() => siteData.title),
      meta: [
        {
          name: "og:title",
          content: computed(() => siteData.title),
        },
        {
          name: "tw:title",
          content: computed(() => siteData.title),
        },
        {
          name: "og:url",
          content: computed(() => siteData.url),
        },
        {
          name: "twitter:url",
          content: computed(() => siteData.url),
        },
      ],
    });
  },
  components: { Hero, Pricing, Benefit },
});
</script>
